module.exports = {
  bindings: {
    reason: '<',
    availability: '=',
    eligibleAccounts: '=',
  },
  template: `
    <div class="select-hcp">
        <h2 class="title -main" translate="preferences_page.titles.select_hcp"></h2>
        <div class="box">
            <fieldset class="field">
                <h3 class="title -sub" translate="preferences_page.titles.none_selected"></h3>
                <ul class="content" name="select-hcp-list">
                  <li class="custom-input -checkbox" ng-repeat="eligibleAccount in $ctrl.eligibleAccounts">
                    <input type="checkbox" id="{{eligibleAccount.account.id}}" ng-model="$ctrl.availability.eligibleAccounts[eligibleAccount.account.id]">
                    <label for="{{eligibleAccount.account.id}}">
                      {{eligibleAccount.account | displayName}}
                      <div class="doctor-availabilities">
                        <p ng-if="eligibleAccount.weeklySchedule">{{eligibleAccount.weeklySchedule}}</p>
                        <p ng-if="!eligibleAccount.weeklySchedule">&nbsp</p>
                      </div>
                    </label>
                  </li>
                </ul>
            </fieldset>
        </div>
    </div>
  `,
};



// WEBPACK FOOTER //
// ./main/components/reasons/reason-select-hcp.js